import React, { useState } from 'react';
import './style.css';
import QCP_API from 'api/qcpApi';
import { useFetch } from '@hooks/useAuthApi';
import '../cards/DarkCard.scss';

const CommentsCCP = ({comment}) => {

  // Full list of comments
  const comments = [
    { id: 1, userId: '001', name: 'John Doe', date: 'Aug 18, 2021', text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
    { id: 2, userId: '002', name: 'Jane Smith', date: 'Aug 19, 2021', text: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.' },
    { id: 3, userId: '003', name: 'Mark Johnson', date: 'Aug 20, 2021', text: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.' },
    { id: 4, userId: '004', name: 'Alice Brown', date: 'Aug 21, 2021', text: 'Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam.' },
    { id: 5, userId: '005', name: 'Robert Wilson', date: 'Aug 22, 2021', text: 'Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur.' },
    { id: 6, userId: '006', name: 'Emily Davis', date: 'Aug 23, 2021', text: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.' },
    { id: 7, userId: '007', name: 'Michael Johnson', date: 'Aug 24, 2021', text: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.' },
    { id: 8, userId: '008', name: 'Sarah Martinez', date: 'Aug 25, 2021', text: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' },
    { id: 9, userId: '009', name: 'David Anderson', date: 'Aug 26, 2021', text: 'Curabitur pretium tincidunt lacus. Nulla gravida orci a odio.' },
    { id: 10, userId: '010', name: 'Sophia Thomas', date: 'Aug 27, 2021', text: 'Vivamus at augue eget arcu dictum varius duis at consectetur.' },
    { id: 11, userId: '011', name: 'William White', date: 'Aug 28, 2021', text: 'Pellentesque nec nam aliquam sem et tortor.' },
    { id: 12, userId: '012', name: 'Olivia Harris', date: 'Aug 29, 2021', text: 'Amet luctus venenatis lectus magna fringilla urna.' },
    { id: 13, userId: '013', name: 'James Clark', date: 'Aug 30, 2021', text: 'Elementum facilisis leo vel fringilla est ullamcorper eget nulla.' },
    { id: 14, userId: '014', name: 'Isabella Lewis', date: 'Aug 31, 2021', text: 'Sit amet consectetur adipiscing elit duis tristique sollicitudin.' },
    { id: 15, userId: '015', name: 'Benjamin Walker', date: 'Sep 1, 2021', text: 'Mauris sit amet massa vitae tortor condimentum lacinia quis.' }
  ];

console.log("comment", comment)

  // State to control how many comments are displayed
  const [visibleComments, setVisibleComments] = useState(8);

  // Function to show 5 more comments
  const showMoreComments = () => {
    setVisibleComments(prev => prev + 5);
  };

  return (
    <React.Fragment>
      <div className='w-full rounded-md bg-gray-50 overflow-hidden border p-3 dark-bg'>
        <div className='w-full flex items-center mb-2'>
          <p className='mb-0 text-md font-semibold'>Comments</p>
        </div>
        
        {/* Scrollable Container with Fixed Height */}
        <div className="max-h-[89vh] min-h-[13vh] overflow-y-auto pr-2 custom-scrollbar">
            {/* Render only the number of comments controlled by visibleComments */}
            {comment?.slice(0, visibleComments).map((data) => (
            <div key={data.id} className="bg-gray-100 hover:bg-gray-200 hover:cursor-pointer rounded px-3 py-2 mt-2 border dark-bg">
                <div className='flex items-center justify-between mb-2'>
                <div className='flex items-start gap-x-3'>
                    {/* <p className='font-medium mb-0'>{data.CommentId}</p> */}
                    <p className='font-semibold text-[12px] mb-0'>{`${data.commentedBy.firstName} ${data.commentedBy.lastName}`}</p>
                </div>
                <p className='text-xs mb-0'>{data.createdDateUTC.split("T")[0]}</p>
                </div>
                <p className='mb-0 text-sm'>{data.commentText}</p>
            </div>
          ))}
        </div>
        {/* Show "See 5 more comments" button if there are more comments to show */}
        {visibleComments < comment?.length && (
            <button 
                onClick={showMoreComments} 
                className="mt-4 hover:underline text-sm">
                See 5 more comments
            </button>
        )}

      </div>
    </React.Fragment>
  );
}

export default CommentsCCP;